import { Record, List, Map as ImmutableMap } from 'immutable';
import LinkIgnoredPropertiesMap from 'MeetingsBase/models/LinkIgnoredPropertiesMap';
const LinkMetadataRecord = Record({
  lastMeetingsLinkCreated: null,
  userChangedSlug: false,
  showSlugCollision: false,
  unverifiedMemberIds: List(),
  avatars: ImmutableMap(),
  ignoredPropertiesMap: new LinkIgnoredPropertiesMap(),
  associatedRosterMembersIds: []
}, 'LinkMetadata');
export default LinkMetadataRecord;